export const EXTENSION_TYPE_NAME = 'da-deviation';
export const popperDropdownConfig = {
    mobileOpenDelay: true
};

//# sourceMappingURL=constants.js.map